import { combineReducers } from 'redux';
import { authReducer } from './authReducer';
import { plansReducer } from './plansReducer';

const root = combineReducers({
    auth: authReducer,
    plan: plansReducer
});

export default root;